<template>
    <div :class="{'chapter__paragraph--inactive': !active}" ref="main">
        <slot></slot>
    </div>
</template>
<script>
    export default {
        beforeDestroy() {
            document.removeEventListener('scroll', this.onScroll);
        },
        mounted() {
            document.addEventListener('scroll', this.onScroll);
        },
        methods: {
            onScroll() {
                if (!this.active) {
                    let rect = this.$refs.main.getBoundingClientRect();
                    if (rect.top + (rect.height / 2) <= window.innerHeight) {
                        this.active = true;
                    }
                }
            }
        },
        data() {
            return {
                active: false,
            }
        }
    }
</script>